import { render, staticRenderFns } from "./MediaWrapperMod.vue?vue&type=template&id=6bb4b17c"
import script from "./MediaWrapperMod.vue?vue&type=script&lang=js"
export * from "./MediaWrapperMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports